module.exports = __webpack_public_path__ + "static/white_dots_small-d883e7cf9b8cfbfa39cde6127c9dfda4.svg";